
import styled from "styled-components";

const Container = styled.div`
  overflow: hidden;
  flex: 1;
`;

const ScrollBox = styled.div`
  height: calc(100vh - 130px - 230px - 30px - 76px);
  overflow: auto;
`;

const Log = styled.div`
  white-space: nowrap;
  padding-right: 20px;
`;

const Link = styled.a`
  color: ${props => props.theme.lightTextColor};
  &:hover {
    text-decoration: underline;
  }
`;

interface ErrorLogProps {
  logs?: string[]
}

const ErrorLog = ({logs}: ErrorLogProps) => {
  return <Container>
    <ScrollBox >
      {logs?.map((log, i) => {
        const apiText = "API Request URL: "
        const splitLog = log.split(apiText);
        const apiUrl = splitLog[1];

        if (log === "") return null;

        return <Log key={`log/${i}`}><span>{`${splitLog[0]}${apiText}`}</span><Link href={apiUrl} target="_blank">{apiUrl}</Link></Log>
      })}
    </ScrollBox>
  </Container>
}

export default ErrorLog;